import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import axios from "axios";
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import Modal from 'react-modal';
import axiosInstance from "../../config/axiosInterceptor";
// import "./Widthdrawal.css"; // We'll define animations here
Modal.setAppElement('#root');

const Widthdrawal = ({ status }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { widthdrawalListsUpdate } = useContext(global);
  const [widthdrawal, setWidthdrawal] = useState([]);
  const [id, setId] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState(""); // controlled input

  const widthdrawalLists = async (status) => {
    try {
      setIsLoading(true);
      setWidthdrawal([]);
      const { data } = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL3}/admin/withdrawal/pending?status=${status}&page=${page}&limit=${limit}`
      );
      if (data.success == 1) {
        setWidthdrawal(data.details);
        setCount(data.total);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    widthdrawalLists(status);
  }, [status, page, limit]);

  // Search API called only when Go is clicked
  const handleSearch = async () => {
    const value = searchInput.trim();
    setSearchQuery(value);
    if (value !== "") {
      setIsLoading(true);
      try {
        setWidthdrawal([]);
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASEURL1}/admin/withdrawal/search?search=${value}&status=${status}&page=${page}`
        );
        setWidthdrawal(data.details);
        setCount(data.details.length);
      } catch (error) {
        toast.error(error.message);
      }
      setIsLoading(false);
    } else {
      widthdrawalLists(status);
    }
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      setSelectedItems(widthdrawal.map(item => ({
        _id: item._id,
        username: item.userId?.username,
        number: item.userId?.number,
        amount: item.coins,
        createdAt: item.createdAt
      })));
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (item) => {
    const isSelected = selectedItems.some(selected => selected._id === item._id);
    if (isSelected) {
      setSelectedItems(selectedItems.filter(selected => selected._id !== item._id));
    } else {
      setSelectedItems([...selectedItems, {
        _id: item._id,
        username: item.userId?.username,
        number: item.userId?.number,
        amount: item.coins,
        createdAt: item.createdAt
      }]);
    }
  };

  const exportToCsv = () => {
    try {
      const csvContent = selectedItems.map(item => ({
        username: item.username,
        number: item.number,
        amount: item.amount,
        date: new Date(item.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
      }));

      const csvRows = [
        ["Username", "Number", "Amount", "Date"],
        ...csvContent.map(item => Object.values(item))
      ];

      const csvString = csvRows.map(row => row.join(",")).join("\n");
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'exported_data.csv');
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  return (
    <>
      {/* Animations for logo and table */}
      <style>{`
        .rotating-logo {
          width: 100px;
          height: 100px;
          animation: spin 2s linear infinite;
        }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        .fade-in { animation: fadeInRow 0.6s cubic-bezier(.4,0,.2,1); }
        @keyframes fadeInRow { from { opacity: 0; transform: translateY(20px);} to { opacity: 1; transform: translateY(0);} }
        .table thead th { background: #0d2235; color: #fff; font-weight: bold; }
        .table-striped > tbody > tr:nth-child(odd) { background: #f8fafd; }
        .table-striped > tbody > tr:nth-child(even) { background: #eef4fa; }
        .table-bordered { border-radius: 10px; overflow: hidden; }
        .search-box-animated { transition: box-shadow 0.3s; border-radius: 24px; }
        .search-box-animated:focus { box-shadow: 0 0 0 2px #2ca8ff; }
        .go-btn { background: linear-gradient(90deg, #2ca8ff, #90caf9); border: none; color: #fff; border-radius: 20px; padding: 8px 26px; font-weight: 500; transition: background .2s; margin-left: 8px;}
        .go-btn:hover { background: linear-gradient(90deg, #1e7fd7, #64b5f6); }
      `}</style>

      <Modal
        isOpen={isLoading}
        contentLabel="Loading Modal"
        style={{
          content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)', textAlign: 'center',
          },
        }}
      >
        <img src='/mastiLive_logo.png' alt="Loading..." className="rotating-logo" />
        <h1>Loading...</h1>
      </Modal>

      <section className="content-header">
        <h1>Widthdrawal List</h1>
        <ol className="breadcrumb">
          <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
          <li className="active">Widthdrawal List</li>
        </ol>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <div className="row" style={{ padding: "16px 0px" }}>
                  <div className="form-group col-xs-4">
                    <label htmlFor="limit">Results per page:</label>
                    <select
                      id="limit"
                      value={limit}
                      onChange={e => { setPage(1); setLimit(Number(e.target.value)) }}
                      className="form-control"
                    >
                      <option value={10}>10</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                    </select>
                  </div>
                  <div className="col-xs-4"></div>
                  <div className="form-group col-xs-4" style={{ display: "flex", alignItems: "flex-start" }}>
                    <label htmlFor="search" style={{ marginRight: 6 }}>Search:</label>
                    <input
                      type="text"
                      id="search"
                      className="form-control search-box-animated"
                      style={{ width: "180px" }}
                      value={searchInput}
                      onChange={e => setSearchInput(e.target.value)}
                      onKeyDown={e => { if (e.key === "Enter") handleSearch(); }}
                    />
                    <button className="go-btn" onClick={handleSearch}>
                      Go
                    </button>
                  </div>
                </div>
                <div className="col-md-2">
                  <button className="btn btn-info" onClick={toggleSelectAll}>
                    {selectAll ? "Deselect All" : "Select All"}
                  </button>
                </div>
                <div>
                  <button type="submit" className="btn btn-info" onClick={exportToCsv} style={{ marginRight: "1rem" }}>
                    Export Data
                  </button>
                </div>
                <div>
                  {selectedItems.length > 0 && status == "0" && (
                    <button type="submit" className="btn btn-success" style={{ margin: "1rem" }} onClick={() => {
                      const conf = window.confirm("Are you Sure, You want to approve all!");
                      if (conf) {
                        setIsLoading(true);
                        for (let i = 0; i < selectedItems.length; i++) {
                          widthdrawalListsUpdate(selectedItems[i]._id, "1");
                        }
                        setIsLoading(false);
                      }
                    }}>
                      Approve All
                    </button>
                  )}
                </div>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          onChange={toggleSelectAll}
                          checked={selectAll}
                        />
                      </th>
                      <th>SR.</th>
                      <th>Date</th>
                      <th>Username</th>
                      <th>Name</th>
                      <th>Number</th>
                      <th>Coins</th>
                      <th>ACC NO</th>
                      <th>BANK NAME</th>
                      <th>IFSC CODE</th>
                      <th>STATUS</th>
                      {status !== "2" && <th>ACTION</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {widthdrawal.length === 0 ? (
                      <tr>
                        <td colSpan={12} style={{ textAlign: "center" }}>
                          No data found
                        </td>
                      </tr>
                    ) : widthdrawal.map((item, index) => {
                      let i = (page - 1) * limit + (index + 1);
                      let d = new Date(item?.createdAt);
                      return (
                        <tr className="fade-in" key={item._id}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedItems.some(selected => selected._id === item._id)}
                              onChange={() => handleCheckboxChange(item)}
                            />
                          </td>
                          <td>{i}</td>
                          <td>{new Date(d).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
                          <td>{item?.userId?.username}</td>
                          <td>{item?.userId?.name}</td>
                          <td>{item?.userId?.number}</td>
                          <td>{item?.coins}</td>
                          <td>{item?.accountNo}</td>
                          <td>{item?.bankName}</td>
                          <td>{item?.ifscCode}</td>
                          <td>
                            {item.status == "0" ? (
                              <span className="label label-info">Pending</span>
                            ) : item.status == "1" ? (
                              <span className="label label-success">Approved</span>
                            ) : (
                              <span className="label label-danger">Rejected</span>
                            )}
                          </td>
                          <td>
                            <ul className="admin-action btn btn-default" style={{ backgroundColor: "#f4f4f4", color: "#fff !important" }}>
                              {status != "2" && (
                                <li className="dropdown">
                                  <a className="dropdown-toggle" style={{ color: "black" }} data-toggle="dropdown" href="#" aria-expanded="false">
                                    Action  
                                  </a>
                                  <ul className="dropdown-menu dropdown-menu-right">
                                    {item.status == 0 ? (
                                      <>
                                        <li role="presentation" onClick={() => widthdrawalListsUpdate(item._id, "1")}>
                                          <Link role="menuitem" tabIndex={-1} to="">
                                            Approve
                                          </Link>
                                        </li>
                                        <li role="presentation" onClick={() => { setId(item._id); widthdrawalListsUpdate(item._id, "2"); }}>
                                          <Link role="menuitem" tabIndex={-1} to="">
                                            Reject
                                          </Link>
                                        </li>
                                        <li role="presentation">
                                          <Link role="menuitem" tabIndex={-1} to={`/admin/viewwidthdrawal/${item.userId._id}`}>
                                            View
                                          </Link>
                                        </li>
                                      </>
                                    ) : item.status == 1 ? (
                                      <>
                                        <li role="presentation" onClick={() => { setId(item._id); widthdrawalListsUpdate(item._id, "2"); }}>
                                          <Link role="menuitem" tabIndex={-1} to="">
                                            Reject
                                          </Link>
                                        </li>
                                        <li role="presentation">
                                          <Link role="menuitem" tabIndex={-1} to={`/admin/viewwidthdrawal/${item.userId._id}`}>
                                            View
                                          </Link>
                                        </li>
                                      </>
                                    ) : (
                                      <>
                                        <li role="presentation" onClick={() => { setId(item._id); widthdrawalListsUpdate(item._id, "1"); }}>
                                          <Link role="menuitem" tabIndex={-1} to="">
                                            Approve
                                          </Link>
                                        </li>
                                        <li role="presentation">
                                          <Link role="menuitem" tabIndex={-1} to={`/admin/viewwidthdrawal/${item.userId._id}`}>
                                            View
                                          </Link>
                                        </li>
                                      </>
                                    )}
                                  </ul>
                                </li>
                              )}
                            </ul>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="row">
                  <div className="col-md-5 text-bold">
                    Total entries : {count}
                  </div>
                  <div className="pagination col-md-5">
                    <li>
                      <span style={{ cursor: "pointer" }} onClick={() => setPage(prev => Math.max(prev - 1, 1))}>Previous</span>
                      <span style={{ cursor: "pointer" }} onClick={() => setPage(prev => (prev < Math.ceil(count / limit) ? prev + 1 : prev))}>Next</span>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Widthdrawal;
